  (function () {
    "use strict";

    var root =
      (window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root) ||
      "/";

    var SECTION_ID = "cart_drawer";

    function cartUsesDrawer() {
      return document.documentElement.getAttribute("data-cart-type") !== "page";
    }

    function getCartPageUrl() {
      var cartUrl = document.documentElement.getAttribute("data-cart-url");
      if (cartUrl) {
        return cartUrl;
      }
      return root + "cart";
    }

    function getDrawer() {
      return document.querySelector("[data-cart-drawer]");
    }

    function getSectionIds() {
      if (!cartUsesDrawer()) {
        return [];
      }

      var drawer = getDrawer();
      var ids = [];

      if (drawer && drawer.dataset.sectionId) {
        ids.push(drawer.dataset.sectionId);
      }

      [SECTION_ID, "cart-drawer"].forEach(function (id) {
        if (ids.indexOf(id) === -1) {
          ids.push(id);
        }
      });

      return ids;
    }

    function getClickTarget(event) {
      var target = event.target;
      if (!target) {
        return null;
      }
      if (target.nodeType === Node.ELEMENT_NODE) {
        return target;
      }
      return target.parentElement;
    }

    function getOverlay() {
      return document.querySelector("[data-cart-overlay]");
    }

    function getItemsContainer() {
      return document.querySelector("[data-cart-items]");
    }

    function openDrawer() {
      if (!cartUsesDrawer()) {
        return;
      }
      var drawer = getDrawer();
      var overlay = getOverlay();
      if (!drawer) {
        return;
      }
      drawer.classList.add("is-open");
      drawer.setAttribute("aria-hidden", "false");
      if (overlay) {
        overlay.classList.add("is-open");
        overlay.setAttribute("aria-hidden", "false");
      }
      document.documentElement.style.overflow = "hidden";
    }

    function closeDrawer() {
      var drawer = getDrawer();
      var overlay = getOverlay();
      if (drawer) {
        drawer.classList.remove("is-open");
        drawer.setAttribute("aria-hidden", "true");
      }
      if (overlay) {
        overlay.classList.remove("is-open");
        overlay.setAttribute("aria-hidden", "true");
      }
      document.documentElement.style.overflow = "";
    }

    function fetchCart() {
      return fetch(root + "cart.js", {
        headers: { Accept: "application/json" },
      }).then(function (res) {
        if (!res.ok) {
          throw new Error("Cart fetch failed");
        }
        return res.json();
      });
    }

    function formatMoney(cents) {
      var format =
        (window.Shopify && window.Shopify.money_format) || "${{amount}}";
      var amount = (cents / 100).toFixed(2);
      return format.replace(/\{\{\s*amount\s*\}\}/, amount);
    }

    function getSectionsUrl() {
      return window.location.pathname + window.location.search;
    }

    function pickSectionHTML(sections) {
      if (!sections) {
        return null;
      }

      var sectionIds = getSectionIds();
      for (var i = 0; i < sectionIds.length; i++) {
        if (sections[sectionIds[i]]) {
          return sections[sectionIds[i]];
        }
      }

      var keys = Object.keys(sections);
      return keys.length ? sections[keys[0]] : null;
    }

    function appendSectionsToFormData(formData) {
      var sectionIds = getSectionIds();
      if (!sectionIds.length) {
        return formData;
      }
      formData.append("sections", sectionIds.join(","));
      formData.append("sections_url", getSectionsUrl());
      return formData;
    }

    function sectionsRequestBody(extra) {
      var body = {};
      var sectionIds = getSectionIds();

      if (sectionIds.length) {
        body.sections = sectionIds.join(",");
        body.sections_url = getSectionsUrl();
      }

      if (extra) {
        Object.keys(extra).forEach(function (key) {
          body[key] = extra[key];
        });
      }

      return body;
    }

    function fetchCartSection() {
      var sectionIds = getSectionIds();
      if (!sectionIds.length) {
        return Promise.resolve(null);
      }

      var sectionsParam = encodeURIComponent(sectionIds.join(","));
      var sectionsUrl = encodeURIComponent(getSectionsUrl());
      var urls = [
        root + "?sections=" + sectionsParam + "&sections_url=" + sectionsUrl,
        root + "?sections=" + sectionsParam,
        root + "cart?sections=" + sectionsParam,
      ];

      function tryUrl(index) {
        if (index >= urls.length) {
          return Promise.resolve(null);
        }

        return fetch(urls[index], {
          headers: { Accept: "application/json" },
          credentials: "same-origin",
        })
          .then(function (res) {
            if (!res.ok) {
              throw new Error("Cart section fetch failed");
            }
            return res.json();
          })
          .then(function (data) {
            return pickSectionHTML(data);
          })
          .catch(function () {
            return tryUrl(index + 1);
          });
      }

      return tryUrl(0);
    }

    function renderEmptyCartState() {
      var drawer = getDrawer();
      var dynamic = drawer && drawer.querySelector("[data-cart-dynamic]");
      var template = drawer && drawer.querySelector("[data-cart-empty-template]");

      if (dynamic && template) {
        dynamic.innerHTML = template.innerHTML;
      }
    }

    function initUpsellCarousel(drawer) {
      if (!drawer) {
        return;
      }

      var track = drawer.querySelector("[data-cart-upsell-track]");
      var prev = drawer.querySelector("[data-cart-upsell-prev]");
      var next = drawer.querySelector("[data-cart-upsell-next]");

      if (!track || !prev || !next) {
        return;
      }

      function updateButtons() {
        var maxScroll = track.scrollWidth - track.clientWidth;
        prev.disabled = track.scrollLeft <= 0;
        next.disabled = track.scrollLeft >= maxScroll - 1;
      }

      prev.addEventListener("click", function () {
        track.scrollBy({ left: -track.clientWidth * 0.85, behavior: "smooth" });
      });

      next.addEventListener("click", function () {
        track.scrollBy({ left: track.clientWidth * 0.85, behavior: "smooth" });
      });

      track.addEventListener("scroll", updateButtons, { passive: true });
      updateButtons();
    }

    function initCartDrawerEnhancements(drawer) {
      initUpsellCarousel(drawer || getDrawer());
    }

    function renderDrawerFromHTML(html) {
      var drawer = getDrawer();
      if (!drawer || !html) {
        return;
      }

      var parsed = new DOMParser().parseFromString(html, "text/html");
      var dynamic = drawer.querySelector("[data-cart-dynamic]");
      var freshDynamic = parsed.querySelector("[data-cart-dynamic]");

      if (dynamic && freshDynamic) {
        dynamic.innerHTML = freshDynamic.innerHTML;
        initCartDrawerEnhancements(drawer);
      }
    }

    function updateCartBadge(count) {
      var badge = document.querySelector("[data-cart-count]");
      if (!badge) {
        return;
      }
      badge.textContent = count;
      if (count > 0) {
        badge.classList.remove("hidden");
      } else {
        badge.classList.add("hidden");
      }
    }

    function findCartLine(key) {
      return document.querySelector(
        '[data-cart-line-item][data-line-key="' + key + '"]'
      );
    }

    function findCartLineForItem(container, item, index) {
      var line = findCartLine(item.key);
      if (line) {
        return line;
      }

      var lines = Array.prototype.slice.call(
        container.querySelectorAll("[data-cart-line-item]")
      );
      var activeLines = lines.filter(function (entry) {
        return !entry.classList.contains("opacity-50");
      });

      return activeLines[index] || lines[index] || null;
    }

    function syncLineKey(line, key) {
      line.dataset.lineKey = key;
      line.setAttribute("data-line-key", key);
      line.querySelectorAll("[data-line-key]").forEach(function (el) {
        el.dataset.lineKey = key;
      });
    }

    function updateLinePrices(line, item) {
      var priceEl = line.querySelector("[data-cart-line-price]");
      if (priceEl) {
        priceEl.textContent = formatMoney(item.final_line_price);
      }

      var compareUnit = parseInt(line.dataset.compareUnitPrice || "0", 10);
      var compareEl = line.querySelector("[data-cart-line-compare]");

      if (compareUnit > item.final_price) {
        var compareLinePrice = compareUnit * item.quantity;
        if (compareEl) {
          compareEl.textContent = formatMoney(compareLinePrice);
        }
      } else if (compareEl) {
        compareEl.remove();
      }
    }

    function updateCartSavings(cart) {
      var savingsEl = document.querySelector("[data-cart-savings]");
      if (!savingsEl) {
        return;
      }

      var container = getItemsContainer();
      var savings = cart.total_discount || 0;

      cart.items.forEach(function (item, index) {
        var line = container
          ? findCartLineForItem(container, item, index)
          : findCartLine(item.key);
        var compareUnit = line
          ? parseInt(line.dataset.compareUnitPrice || "0", 10)
          : 0;

        if (compareUnit > item.final_price) {
          savings += compareUnit * item.quantity - item.final_line_price;
        }
      });

      savingsEl.textContent = formatMoney(savings);
    }

    function setLineQuantity(line, quantity) {
      var qtyEl = line.querySelector("[data-cart-line-quantity]");
      var minus = line.querySelector("[data-cart-quantity-minus]");
      var plus = line.querySelector("[data-cart-quantity-plus]");

      if (qtyEl) {
        qtyEl.textContent = quantity;
      }
      if (minus) {
        minus.dataset.qty = String(quantity - 1);
        minus.disabled = quantity <= 1;
      }
      if (plus) {
        plus.dataset.qty = String(quantity + 1);
      }
    }

    function setLinePending(line, pending) {
      if (!line) {
        return;
      }
      line.classList.toggle("opacity-50", pending);
      line.classList.toggle("pointer-events-none", pending);
    }

    function updateProgressBar(cart) {
      var progress = document.querySelector("[data-cart-progress]");
      if (!progress) {
        return;
      }

      var cartTotal = cart.total_price;
      var shippingThreshold = parseInt(
        progress.dataset.shippingThreshold || "0",
        10
      );
      var giftThreshold = parseInt(progress.dataset.giftThreshold || "0", 10);
      var showGift = progress.dataset.showGift === "true";
      var maxThreshold = 0;

      if (showGift && giftThreshold > shippingThreshold) {
        maxThreshold = giftThreshold;
      } else if (shippingThreshold > 0) {
        maxThreshold = shippingThreshold;
      } else if (showGift) {
        maxThreshold = giftThreshold;
      }

      if (maxThreshold <= 0) {
        return;
      }

      var percent = Math.min(100, Math.round((cartTotal * 100) / maxThreshold));
      var bar = progress.querySelector("[data-cart-progress-bar]");
      if (bar) {
        bar.style.width = percent + "%";
      }

      progress.dataset.cartTotal = String(cartTotal);
    }

    function updateCartFromJson(cart) {
      updateCartBadge(cart.item_count);
      updateProgressBar(cart);

      var container = getItemsContainer();
      if (!container) {
        if (cart.item_count === 0) {
          renderEmptyCartState();
        }
        return;
      }

      if (cart.item_count === 0) {
        renderEmptyCartState();
        return;
      }

      var cartKeys = {};

      cart.items.forEach(function (item, index) {
        var line = findCartLineForItem(container, item, index);

        if (!line) {
          return;
        }

        syncLineKey(line, item.key);
        cartKeys[item.key] = true;
        line.dataset.unitPrice = String(item.final_price);
        setLineQuantity(line, item.quantity);
        setLinePending(line, false);
        updateLinePrices(line, item);
      });

      container.querySelectorAll("[data-cart-line-item]").forEach(function (line) {
        var key = line.getAttribute("data-line-key");
        if (!cartKeys[key]) {
          line.remove();
        }
      });

      var subtotal = document.querySelector("[data-cart-subtotal]");
      if (subtotal) {
        subtotal.textContent = formatMoney(cart.total_price);
      }

      updateCartSavings(cart);
    }

    function cartNeedsSectionRender(cart) {
      if (!cartUsesDrawer()) {
        return false;
      }

      if (cart.item_count === 0) {
        return true;
      }

      var container = getItemsContainer();
      if (!container) {
        return true;
      }

      var domLines = container.querySelectorAll("[data-cart-line-item]");
      if (cart.items.length !== domLines.length) {
        return true;
      }

      var drawer = getDrawer();
      var recommendations = drawer && drawer.querySelector("cart-drawer-recommendations");
      if (recommendations && recommendations.dataset.url && cart.items[0]) {
        var match = recommendations.dataset.url.match(/product_id=(\d+)/);
        if (match && String(cart.items[0].product_id) !== match[1]) {
          return true;
        }
      }

      for (var i = 0; i < cart.items.length; i++) {
        if (domLines[i].dataset.lineKey !== cart.items[i].key) {
          return true;
        }
      }

      return false;
    }

    function applySectionsFromResponse(data) {
      var html = pickSectionHTML(data && data.sections);
      if (!html) {
        return false;
      }
      renderDrawerFromHTML(html);
      return true;
    }

    function refreshCartFromSection() {
      return fetchCartSection()
        .then(function (html) {
          if (html) {
            renderDrawerFromHTML(html);
          }

          return fetchCart().then(function (cart) {
            updateCartBadge(cart.item_count);

            if (!html && cartNeedsSectionRender(cart) && getItemsContainer()) {
              updateCartFromJson(cart);
            } else if (!html && cart.item_count === 0) {
              renderEmptyCartState();
            } else if (html) {
              updateProgressBar(cart);
            }

            return cart;
          });
        });
    }

    function refreshCart() {
      return fetchCart().then(function (cart) {
        if (cartNeedsSectionRender(cart)) {
          return refreshCartFromSection();
        }

        updateCartFromJson(cart);
        return cart;
      });
    }

    function applyCartUpdate(cart, sectionsData) {
      if (applySectionsFromResponse(sectionsData || cart)) {
        updateCartBadge(cart.item_count);
        updateProgressBar(cart);
        return Promise.resolve(cart);
      }

      if (cartNeedsSectionRender(cart)) {
        return refreshCartFromSection();
      }

      updateCartFromJson(cart);
      return Promise.resolve(cart);
    }

    function changeLine(lineKey, quantity, trigger) {
      var line = findCartLine(lineKey);
      var previousQty = null;

      if (line) {
        var qtyEl = line.querySelector("[data-cart-line-quantity]");
        previousQty = qtyEl ? parseInt(qtyEl.textContent, 10) : null;

        if (quantity === 0) {
          setLinePending(line, true);
        } else {
          setLineQuantity(line, quantity);
        }

        if (previousQty !== null) {
          var badge = document.querySelector("[data-cart-count]");
          if (badge) {
            var badgeCount = parseInt(badge.textContent, 10) || 0;
            var nextCount =
              quantity === 0
                ? badgeCount - previousQty
                : badgeCount + (quantity - previousQty);
            badge.textContent = Math.max(0, nextCount);
            badge.classList.toggle("hidden", nextCount <= 0);
          }
        }
      }

      if (trigger) {
        trigger.disabled = true;
      }

      return fetch(root + "cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(
          sectionsRequestBody({ id: lineKey, quantity: quantity })
        ),
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) {
              throw data;
            }
            return data;
          });
        })
        .then(function (cart) {
          if (quantity === 0 && line) {
            line.remove();
          }

          if (quantity === 0 || cart.item_count === 0) {
            if (applySectionsFromResponse(cart)) {
              updateCartBadge(cart.item_count);
              return cart;
            }
            return refreshCartFromSection();
          }

          return applyCartUpdate(cart, cart);
        })
        .catch(function (err) {
          if (line && previousQty !== null) {
            setLineQuantity(line, previousQty);
            setLinePending(line, false);
          }
          throw err;
        })
        .finally(function () {
          if (trigger) {
            trigger.disabled = false;
          }
        });
    }

    function addUpsellVariant(variantId, trigger) {
      if (!variantId) {
        return Promise.resolve();
      }

      var defaultLabel = trigger
        ? (trigger.querySelector("[data-cart-upsell-add-label]") || trigger)
            .textContent
        : "";

      if (trigger) {
        trigger.disabled = true;
        var labelEl = trigger.querySelector("[data-cart-upsell-add-label]");
        if (labelEl) {
          labelEl.textContent = "…";
        }
      }

      return fetch(root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(
          sectionsRequestBody({ id: variantId, quantity: 1 })
        ),
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) {
              throw data;
            }
            return data;
          });
        })
        .then(function (data) {
          if (applySectionsFromResponse(data)) {
            return fetchCart().then(function (cart) {
              updateCartBadge(cart.item_count);
              updateProgressBar(cart);
              return cart;
            });
          }
          return refreshCartFromSection();
        })
        .catch(function () {
          if (trigger) {
            var labelEl = trigger.querySelector("[data-cart-upsell-add-label]");
            if (labelEl) {
              labelEl.textContent = defaultLabel;
            }
          }
        })
        .finally(function () {
          if (trigger) {
            trigger.disabled = false;
            var labelEl = trigger.querySelector("[data-cart-upsell-add-label]");
            if (labelEl && labelEl.textContent === "…") {
              labelEl.textContent = defaultLabel;
            }
          }
        });
    }

    function showFormError(form, message) {
      var el = form.querySelector("[data-product-form-error]");
      if (!el) {
        el = document.createElement("p");
        el.setAttribute("data-product-form-error", "");
        el.className = "mt-2 text-sm text-text";
        form.appendChild(el);
      }
      el.hidden = false;
      el.textContent = message;
    }

    function clearFormError(form) {
      var el = form.querySelector("[data-product-form-error]");
      if (el) {
        el.hidden = true;
        el.textContent = "";
      }
    }

    function isDrawerOpen() {
      var drawer = getDrawer();
      return drawer && drawer.classList.contains("is-open");
    }

    class CartDrawerRecommendations extends HTMLElement {
      connectedCallback() {
        if (this.dataset.recommendationsLoaded === "true") {
          return;
        }

        var element = this;
        var track = element.querySelector("[data-cart-upsell-track]");
        if (!track) {
          return;
        }

        function applyRecommendations(text) {
          var html = document.createElement("div");
          html.innerHTML = text;
          var items = html.querySelector("[data-cart-upsell-items]");

          if (items && items.innerHTML.trim().length) {
            track.innerHTML = items.innerHTML;
            element.dataset.recommendationsLoaded = "true";
            initUpsellCarousel(getDrawer());
            return true;
          }

          return false;
        }

        function hideIfEmpty() {
          if (!track.children.length) {
            var upsells = element.closest("[data-cart-upsells]");
            if (upsells) {
              upsells.hidden = true;
            }
          }
        }

        function fetchRecommendations(url) {
          return fetch(url).then(function (response) {
            if (!response.ok) {
              throw new Error("Cart upsell request failed");
            }
            return response.text();
          });
        }

        var url = element.dataset.url;
        if (!url) {
          hideIfEmpty();
          return;
        }

        fetchRecommendations(url)
          .then(function (text) {
            if (applyRecommendations(text)) {
              return;
            }

            var fallbackUrl = element.dataset.fallbackUrl;
            if (!fallbackUrl) {
              hideIfEmpty();
              return;
            }

            return fetchRecommendations(fallbackUrl).then(function (fallbackText) {
              if (!applyRecommendations(fallbackText)) {
                hideIfEmpty();
              }
            });
          })
          .catch(function () {
            hideIfEmpty();
          });
      }
    }

    if (!customElements.get("cart-drawer-recommendations")) {
      customElements.define(
        "cart-drawer-recommendations",
        CartDrawerRecommendations
      );
    }

    document.addEventListener("DOMContentLoaded", function () {
      initCartDrawerEnhancements(getDrawer());
    });

    document.addEventListener("cart:open", openDrawer);
    document.addEventListener("cart:close-request", closeDrawer);

    document.addEventListener("click", function (event) {
      var clickTarget = getClickTarget(event);
      if (!clickTarget || !clickTarget.closest) {
        return;
      }

      var openBtn = clickTarget.closest("[data-cart-open]");
      if (openBtn) {
        if (!cartUsesDrawer()) {
          return;
        }
        event.preventDefault();
        document.dispatchEvent(new CustomEvent("cart:open"));
        return;
      }

      if (clickTarget.closest("[data-cart-close]")) {
        event.preventDefault();
        closeDrawer();
        return;
      }

      if (isDrawerOpen()) {
        var drawer = getDrawer();
        var clickedDrawer = drawer && drawer.contains(clickTarget);
        var clickedOverlay = clickTarget.closest("[data-cart-overlay]");

        if (clickedOverlay || !clickedDrawer) {
          closeDrawer();
          return;
        }
      }

      var minus = clickTarget.closest("[data-cart-quantity-minus]");
      var plus = clickTarget.closest("[data-cart-quantity-plus]");
      var remove = clickTarget.closest("[data-cart-remove]");
      var upsellAdd = clickTarget.closest("[data-cart-upsell-add]");

      if (minus && !minus.disabled) {
        event.preventDefault();
        changeLine(minus.dataset.lineKey, parseInt(minus.dataset.qty, 10), minus);
        return;
      }

      if (plus) {
        event.preventDefault();
        changeLine(plus.dataset.lineKey, parseInt(plus.dataset.qty, 10), plus);
        return;
      }

      if (remove) {
        event.preventDefault();
        changeLine(remove.dataset.lineKey, 0, remove);
        return;
      }

      if (upsellAdd && !upsellAdd.disabled) {
        event.preventDefault();
        event.stopPropagation();
        addUpsellVariant(parseInt(upsellAdd.dataset.variantId, 10), upsellAdd);
      }
    });

    document.addEventListener("submit", function (event) {
      var form =
        event.target.closest("[data-product-form]") ||
        event.target.closest("form.main-product__form");
      if (!form) {
        return;
      }
      event.preventDefault();

      var submitButtons = getProductSubmitButtons(form);
      var addingLabel =
        form.dataset.addingToCartLabel || "Adding to cart";
      var defaultLabel = form.dataset.addToCartLabel || "Add to cart";

      submitButtons.forEach(function (submitBtn) {
        submitBtn.setAttribute("disabled", "disabled");
        setProductSubmitLabel(submitBtn, addingLabel);
      });
      clearFormError(form);

      var formData = appendSectionsToFormData(new FormData(form));

      fetch(root + "cart/add.js", {
        method: "POST",
        headers: { Accept: "application/json" },
        credentials: "same-origin",
        body: formData,
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) {
              throw data;
            }
            return data;
          });
        })
        .then(function (data) {
          if (!cartUsesDrawer()) {
            window.location.assign(getCartPageUrl());
            return null;
          }

          if (applySectionsFromResponse(data)) {
            return fetchCart().then(function (cart) {
              updateCartBadge(cart.item_count);
              updateProgressBar(cart);
              return cart;
            });
          }
          return refreshCartFromSection();
        })
        .then(function (cart) {
          if (!cartUsesDrawer() || cart === null) {
            return;
          }
          openDrawer();
        })
        .catch(function (err) {
          showFormError(
            form,
            (err && err.description) || "Sorry, this item could not be added."
          );
        })
        .finally(function () {
          if (!cartUsesDrawer()) {
            return;
          }
          submitButtons.forEach(function (submitBtn) {
            submitBtn.removeAttribute("disabled");
            setProductSubmitLabel(submitBtn, defaultLabel);
          });
        });
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        closeDrawer();
      }
    });

    function setProductSubmitLabel(button, text) {
      if (!button) return;

      var labelEl = button.querySelector(
        "[data-product-submit-label], [data-product-sticky-submit-label]"
      );

      if (labelEl) {
        labelEl.textContent = text;
      } else {
        button.textContent = text;
      }
    }

    function getProductSubmitButtons(form) {
      var buttons = [];
      var mainSubmit = form.querySelector("[data-product-submit]");

      if (mainSubmit) {
        buttons.push(mainSubmit);
      }

      var stickySubmit = document.querySelector("[data-product-sticky-submit]");
      if (stickySubmit) {
        buttons.push(stickySubmit);
      }

      return buttons;
    }
  })();
